<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{'--width': widthVar}"  class="pageHeader">学生开放预约处理</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">

        
         <el-form-item label="学生姓名">
          <el-input v-model="formInline.user_name" clearable placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增</el-button>
        </el-form-item> -->
        <!-- <el-form-item>
          <el-button type="primary" @click="handlePrint">打印</el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column prop="order_user_name" label="学生姓名" width="120">
        </custom-table-column>
        <custom-table-column prop="training_room_name" :label="`${$store.state.themeTitle}室`" width="120">
        </custom-table-column>
        <custom-table-column prop="status" label="申请状态" width="160"  :formatter="format_status_str">
        </custom-table-column>
        <custom-table-column prop="is_wy" label="是否违约" width="160">
          <template slot-scope="scope">
            <span v-if="scope.row.is_wy" style="color:var(--red);">是</span>
            <span v-else style="color:var(--ligtGreen);">否</span>
          </template>
        </custom-table-column>
        <custom-table-column prop="order_start" label="开始时间" width="160px">
        </custom-table-column>
        <custom-table-column prop="order_end" label="结束时间" width="160px">
        </custom-table-column>
        <custom-table-column prop="reason" label="申请理由" min-width="220px">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="142">
          <template slot-scope="scope">
            <el-button @click="handleDetailClick(scope.row)" type="text" size="small">详情</el-button>
            <el-button v-if="scope.row.status=='apply'" @click="handleOper(scope.row.id,'pass')" type="text" size="small">通过</el-button>
            <el-button v-if="scope.row.status=='apply'" @click="handleOper(scope.row.id,'refuse')" type="text" size="small">否决</el-button>
            <el-button v-if="scope.row.status=='pass' && (!scope.row.is_wy)" @click="handleAddRecode(scope.row.id)" type="text" size="small">添加违约记录</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>

    <el-dialog :close-on-click-modal="false" title="添加违约记录" :visible.sync="numberDialogVisible" width="406px">
      <el-form :model="ruleForm1" :rules="rules1" ref="ruleForm1" label-width="100px" class="demo-ruleForm">
        <el-form-item label="违约时间" prop="default_time">
          <el-date-picker type="datetime" placeholder="选择违约时间" value-format="yyyy-MM-dd HH:mm:ss" v-model="ruleForm1.default_time" style="width:242px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="违约说明" prop="desc">
          <el-input type="textarea" v-model="ruleForm1.desc" placeholder="请输入违约说明" style="width:242px;" :rows="4"></el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" @click="submitFormByFun('ruleForm1',addRecode)">确认</el-button>
          <el-button @click="resetForm('ruleForm1')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="申请详情" :visible.sync="detailDialogVisible" width="746px">
      <el-descriptions class="margin-top" title="" direction="vertical" :column="2"  border>
        <el-descriptions-item>
          <template slot="label">{{$store.state.themeTitle}}室 </template> {{rowObj.training_room_name}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">申请状态 </template> 
          <span v-if="rowObj.status=='apply'" style="color:var(--blue);">待审核</span>
          <span v-if="rowObj.status=='pass'" style="color:var(--ligtGreen);">已通过</span>
          <span v-if="rowObj.status=='refuse'" style="color:var(--red);">已拒绝</span>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">开始时间 </template> {{rowObj.order_start}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">结束时间 </template> {{rowObj.order_end}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">申请理由 </template> {{rowObj.reason}}
        </el-descriptions-item>
      </el-descriptions>
      <p style="font-size: 16px;font-weight: 700;color:#111;margin-top:32px;margin-bottom:20px;">申请清单</p>
      <el-descriptions class="margin-top" title="" style="margin-bottom:16px;" v-for="(item,index) in listArr" :key="index" direction="vertical" :column="2"  border>
        <el-descriptions-item>
          <template slot="label">名 称 </template> {{item.item_name}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">数 量 </template> {{item.item_num}}
        </el-descriptions-item>
      </el-descriptions>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteDeviceInto">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinFormatter } from '@/assets/js/mixin/formatter';

export default {
  name: 'equipmentInto',
  mixins: [mixinList,mixinFormatter],
  data() {
    return {
      formInline: {
        user_name: '',
      },
      detailDialogVisible: false,
      numberDialogVisible:false,
      eqs: [],
      rowObj: [],
      scraps: [{ isid: '1', ismc: '普通' }],
      total: 40,
      ruleForm: {
        training_room_id: '',
        order_start: '',
        order_end: '',
        reason: '',
        items: [],
      },
      ruleForm1: {
        id: '',
        default_time: '',
        desc: '',
      },
      rules1: {
        default_time: [{ required: true, message: '请选择违约时间', trigger: 'change' }],
        desc: [{ required: true, message: '请输入违约说明', trigger: 'blur' }],
      },
      listArr:[],
      remainder_quantity: 0,
      rules: {
        training_room_id: [{ required: true, message: `请选择${this.$store.state.themeTitle}室`, trigger: 'change' }],
        order_start: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
        order_end: [{ required: true, message: '请选择结束时间', trigger: 'change' }],
        reason: [{ required: true, message: '申请理由不能为空', trigger: 'blur' }],
      },
      rules1: {},
    };
  },
  components: {},
  created() {},
  mounted() {
    // this.getStudentApply()
    // this.getProvince()
    this.$store.dispatch('getTarinMent', { type: 'all' });
  },
  methods: {
    handleOper(id,status) {
      let str = '通过';
      if (status == 'refuse') {
        str = '否决';
      }
      this.confirmBox('warning', `此操作将${str}该学生的预约申请，是否继续`, { id,status }, this.setStatus);
    },
    async addRecode() {
      let params = this.$until.easyDeepCopy(this.ruleForm);1;
      let res = await this.$api.instance.interfaceServer(`api/open_reservation/wyRecord/add`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '添加记录成功！',
        });
        this.ruleForm1 = {
          id: '',
          default_time: '',
          desc: '',
        };
        this.numberDialogVisible = false;
        this.handleQuery();
      }
    },
    handleAddRecode(id) {
      this.numberDialogVisible = true;
      this.ruleForm1.id = id;
    },
    handleDetailClick(row) {
      this.rowObj = row;
      this.listArr = row.items;
      this.detailDialogVisible = true;
    },
    async setStatus(params) {
      let res = await this.$api.instance.interfaceServer(`api/open_reservation/apply/oper/${params.id}`, 'post',{status:params.status});
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '处理成功！',
        });
        this.getList();
      }
    },
    async handleClassChange(e) {
      if (this.ruleForm.training_room_id) {
        let params = { training_room_id: this.ruleForm.training_room_id };
        params.page = 1;
        params.size = 9999;
        let res = await this.$api.instance.interfaceServer('api/training/common/room/device/list', 'get', params);
        if (res.code == 0 && res.data) {
          this.eqs = res.data.data;
        }
      } else {
        this.eq = [];
      }
    },
    onSubmit() {
      console.log('submit!');
    },
    handleSet() {
      this.centerDialogVisible = true;
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    handleBack() {
      this.$message.info('撤销中。。。');
    },
    handleExport() {
      this.$message.info('导出中。。。');
    },
    handlePrint() {
      this.$message.info('打印中。。。');
    },
    async deleteDeviceInto() {
      let params = { id: this.delid };
      let res = await this.$api.delet.deleteDeviceScrap(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async createDeviceInto() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      params.items = params.items.map((item) => {
        return {
          type: item.type,
          name: item.name,
          num: item.num,
          id: item.id,
        };
      });
      params.items = JSON.stringify(params.items);
      let res = await this.$api.instance.interfaceServer('api/open_reservation/apply/add', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    // async updateJournalOfTearcher() {
    //   let params = this.$until.easyDeepCopy(this.ruleForm);;
    //   let res = await this.$api.update.updateJournalOfTearcher(params);
    //   if (res.code == 0) {
    //     this.$message({
    //       type: 'success',
    //       center: true,
    //       message: '编辑成功！',
    //     });
    //     this.clearState();
    //   }
    // },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/open_reservation/apply/listAll', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    handleQuery() {
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    resetForm(formName) {
      this.ruleForm.device_price = 0;
      this.remainder_quantity = 0;
      this.$refs[formName].resetFields();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // if (this.type == 'add') {
          this.createDeviceInto();
          // }else if(this.type == 'edit'){
          //   this.updateJournalOfTearcher()
          // }
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
